/* eslint-disable camelcase, react/jsx-pascal-case */
import SelectBox_ListPreviewGrouped from './selectBox_ListPreviewGrouped';

export default SelectBox_ListPreviewGrouped;
